function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckBoxOptionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "36px",
    height: "30px",
    viewBox: "0 0 36 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,15.686275%,33.333333%)",
      strokeOpacity: 0.74902,
      strokeMiterlimit: 4
    },
    d: "M 1 4.25 L 5.5 8.75 L 11 1.25 ",
    transform: "matrix(3,0,0,3,0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoxOptionIcon);
export default __webpack_public_path__ + "static/media/check-box-option-icon.c1c8b9f16ca78236d228e5f63a7564db.svg";
export { ForwardRef as ReactComponent };